import { Badge, Flex, Grid, Loader } from "@aws-amplify/ui-react";
import { CCard } from "@coreui/react";
import { useContext, useEffect, useState } from "react";
import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";
import { API, graphqlOperation } from "aws-amplify";

import { getTool } from "graphql/queries";
import { useOnlineStatus } from "hooks/useOnlineStatus";
import { OrderContext } from "components/serviceOrders/context/OrderContext";
import { localGetServiceOrder } from "libs/idb/service-orders-db";

const ToolsInfo = ({ toolIDs }) => {
  const online = useOnlineStatus();
  const { serviceOrder } = useContext(OrderContext);
  const [tools, setTools] = useState({ data: [], loading: false });

  const getToolData = async (ids) => {
    try {
      setTools({ data: [], loading: true });

      if (!online) {
        const localData = await localGetServiceOrder(serviceOrder.id);
        const toolsFound = localData?.tools ?? [];
        setTools((prev) => ({ ...prev, data: toolsFound }));
        return;
      }

      let toolsItems = [];
      if (ids?.length > 0) {
        await Promise.all(
          ids.map(async (id) => {
            const toolData = await API.graphql(
              graphqlOperation(getTool, {
                id,
              })
            );
            const toolItem = toolData.data.getTool;
            toolsItems.push(toolItem);
          }) ?? []
        );
      }

      setTools((prev) => ({ ...prev, data: toolsItems }));
    } catch (err) {
      toast.error(strings.errors.fetchTools);
    } finally {
      setTools((prev) => ({ ...prev, loading: false }));
    }
  };

  useEffect(() => {
    if (toolIDs?.length > 0) getToolData(toolIDs);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [toolIDs]);

  return (
    <CCard
      className="p-3"
      borderRadius="medium"
      variation="outlined"
      style={{ height: "100%" }}
    >
      <Grid gap="5px">
        <span className="fs-5">{strings.tools}</span>
        {tools.loading ? (
          <Loader />
        ) : tools.data.length > 0 ? (
          <Flex rowGap="10px" columnGap="10px" wrap="wrap">
            {tools.data.map((tool, index) => (
              <Badge key={index}>{tool.name}</Badge>
            ))}
          </Flex>
        ) : (
          strings.noTools
        )}
      </Grid>
    </CCard>
  );
};

const strings = new LocalizedStrings({
  es: {
    tools: "Herramientas de la Orden",
    name: "Nombre",
    description: "Descripción",
    location: "Ubicación",
    errors: {
      fetchTools: "Error al consultar las herramientas",
    },
    noTools: "Sin herramientas...",
  },
});

export default ToolsInfo;
